<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog v-model="dialog" persistent width="850" class="border-radius-3" hide-overlay>
            <v-card class="border-radius-3 pa-10">
                <v-card-title class=" d-flex justify-center"
                    ><span
                        class="titles text-h6 font-weight-medium primary--text py-3 d-flex justify-center"
                        >{{ $t('initialTour.categories_select') }}</span
                    ></v-card-title
                >
                <v-container class=" height-viewport-100">
                    <div class="d-flex justify-content category-content">
                        <v-row class="pa-0 ma-0 main-categories">
                            <v-col
                                cols="2"
                                v-for="(category, index) of categories"
                                :key="index"
                                class="pa-0 ma-2"
                            >
                                <Category :data="category"></Category>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        data-cy="continue-button-category-select"
                        color="secondary px-15"
                        :loading="btnLoaded"
                        large
                        rounded
                        @click="nextPass"
                        >{{ $t('initialTour.continue') }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import UserService from '@/services/users'
import Category from './CategoriesCore/Category.vue'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components: {
        Category,
    },
    computed: {
        ...mapState(['categories']),
        ...mapState({
            stCategories: (state) => state.userData.selectedCategories,
            stUserAvatar: (state) => state.userData.avatarSelected,
            stUser: (state) => state.userData.user,
            survey: (state) => state.userData.survey,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
        }),
    },
    data() {
        return {
            select_categories: [],
            selectedCategoriesObj: [],
            btnLoaded: false,
        }
    },
    methods: {
        ...mapActions('dashboard', [
            'showCategories',
            'showAvatars',
            'showInitialPoll',
            'mountDiagnostic',
            'showFinishPreferencesModal',
        ]),
        ...mapActions('userData', ['changeCategories']),
        searchCategorySelected(categoryId) {
            return this.categories.find(
                (categoryFromList) => Number(categoryId) === Number(categoryFromList.id)
            )
        },
        async nextPass() {
            const vm = this
            document.querySelectorAll('.category-active').forEach((obj) => {
                const id = obj.getAttribute('data-category-id')
                vm.select_categories.push(id)
                vm.selectedCategoriesObj.push(this.searchCategorySelected(id))
            })

            if (this.select_categories.length < 1) {
                this.$modal.error(this.$t('initialTour.msg_categories_not_select'))
                return
            }
            this.changeCategories(this.selectedCategoriesObj)

            this.btnLoaded = true
            await this.updateUserPreferences({
                userId: this.stUser.id,
                avatar: this.stUserAvatar.id,
                userAvatar: this.stUserAvatar.id,
                categories: this.select_categories,
            })
            this.btnLoaded = false
            this.showCategories()
            this.showFinishPreferencesModal()
        },
        updateUserPreferences(data) {
            return new Promise((resolve, reject) => {
                UserService.updateUserPreferences(data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
            })
        },
    },
}
</script>
<style>

.category-content {
    height: 50vh;
    overflow: auto;
}

.main-categories {
    justify-content: center;
    align-items: self-start;
    align-content: start;
}

.category-img {
    display: block;
    max-width: 52vh;
    height: 5vh;
}

.sm-category-img {
    display: block;
    max-width: 52vh;
    height: 4vh;
}

.category-active .category-box {
    border: 1vh solid #4caf50;
}

.category-check {
    display: none;
}
.category-active .category-check {
    bottom: -12px;
    right: 0px;
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
}

.category-active .sm-category-img {
    height: 5vh;
}
</style>
